'use strict';

import { hostFactory as hostInstance } from "@api/factory";

import { LoggerBus } from '@app/utils/logger-bus';
import EventBus from '@app/utils/event-bus';
const loggerFormat = '[api::my::events]';

const eventIndex = () =>{
  LoggerBus.$log.debug(loggerFormat);
  return hostInstance.get(`/api/my/events`);
}

const eventStore = (event, headers={}) => {
  LoggerBus.$log.debug(loggerFormat);
  return hostInstance.post(`/api/my/events`, event, headers);
}

const eventShow = eventId =>{
  LoggerBus.$log.debug(loggerFormat);
  return hostInstance.get(`/api/my/events/${eventId}`);
}

const eventUpdate = (eventId, updatedEvent, headers={}) =>{
  LoggerBus.$log.debug(headers);
  return hostInstance.post(`/api/my/events/${eventId}`, updatedEvent, headers);
}

const eventActivate = (eventId) =>{
  LoggerBus.$log.debug(loggerFormat);
  return hostInstance.patch(`/api/my/events/${eventId}/enable`);
}

const eventDeactivate = (eventId) =>{
  LoggerBus.$log.debug(loggerFormat);
  return hostInstance.patch(`/api/my/events/${eventId}/disable`);
}

const eventDestroy = (eventId) =>{
  LoggerBus.$log.debug(loggerFormat);
  return hostInstance.delete(`/api/my/events/${eventId}`);
}

const eventDestroyFile = (eventId, fileId) =>{
  LoggerBus.$log.debug(loggerFormat);
  return hostInstance.delete(`/api/my/events/${eventId}/files/${fileId}`);
}

const eventDownloadFile = async (eventId, fileId) =>{
  LoggerBus.$log.debug(loggerFormat);
  
  let progress = 0;
  const opts = {
    responseType: 'arraybuffer',
    onDownloadProgress: (progressEvent) => {
      progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
      EventBus.DownloadProgressBar.$emit('onDownloadProgress', {progress: progress});
    }
  };

  return await hostInstance.get(`/api/my/events/${eventId}/files/${fileId}/download`, opts);
}

const getTraineeEvent = (companyId, userId) =>{
  LoggerBus.$log.debug(loggerFormat);
  return hostInstance.get(`/api/companies/${companyId}/users/${userId}/events`);
}

export default {
  eventIndex,
  eventStore,
  eventShow,
  eventUpdate,
  eventActivate,
  eventDeactivate,
  eventDestroy,
  eventDestroyFile,
  eventDownloadFile,
  getTraineeEvent
};